<div class="col-lg-12 col-md-12">
  <div class="form-group action-add-remove-group" cdkDropListGroup>
    <span>Dropdown values</span>
    <div cdkDropList (cdkDropListDropped)="valuesReordered.emit($event)">
      <div
        class="d-flex align-items-center mb-2 row-table"
        *ngFor="let Value of valueControl?.controls; let i = index"
        [formGroup]="valueFormGroup(Value)"
        cdkDrag
        [cdkDragData]="i"
      >
        <div class="grab-icon">
          <img src="assets/images/icons/field-icon.svg" alt="" class="grabbable" />
        </div>

        <div class="pt-3">
          <app-checkbox
            [form]="valueFormGroup(Value)"
            controlName="IsActive"
          ></app-checkbox>
        </div>

        <div class="flex-grow-1 me-2">
          <input
            class="form-control"
            type="text"
            formControlName="value"
            name="value"
          />
        </div>

        <div class="action-controls">
          <button
            (click)="valueRemoved.emit(i)"
            class="btn btn-danger btn-remove"
          >
            <i class="icon-delete delete-icon"></i>
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-2">
        <button
          type="button"
          (click)="valueAdded.emit()"
          class="btn btn-primary btn-add"
        >
          <i class="icon-add"></i>
        </button>
      </div>
    </div>
  </div>
</div>
